import { createReducer, on } from '@ngrx/store';
import { ShowError } from '../containers/show-error/models/show-error';
import { CoreActions, CoreApiActions } from './core.action';
import { ConfigAppOutputDto } from '@shared/api/model/config-app-output-dto';
import { TimezoneAppItemOutputDto } from '@shared/api/model/timezone-app-item-output-dto';

export const CORE_FEATURE_KEY = 'core';

export interface CoreState {
  loading?: boolean;
  actualRoute: string
  error?: ShowError;
  appConfig?: ConfigAppOutputDto;
  timezone?: TimezoneAppItemOutputDto;
  timezonesList?: TimezoneAppItemOutputDto[];
}

export const initialState: CoreState = {
  actualRoute: '/home',
  loading: false,
  error: undefined,
  appConfig: undefined,
  timezone: undefined,
  timezonesList: []
};

export const coreReducer = createReducer(
  initialState,
  on(CoreActions.init,
    (_state) => { return { ..._state, loading: false } }),
  on(CoreApiActions.loadMenuItems,
    (_state) => { return { ..._state, loading: true } }),
  on(CoreApiActions.loadMenuItemsSuccess,
    (_state) => { return { ..._state, loading: false } }),
  on(CoreActions.throwError,
    (_state, { error }) => { return { ..._state, error: error } }),
  on(CoreApiActions.loadAppConfigSuccess,
      (_state, { appConfig }) => { return { ..._state, appConfig: appConfig } }),
  on(CoreActions.setTimezoneSuccess,
      (_state, { timezone }) => { return { ..._state, timezone } }),
  on(CoreApiActions.loadTimezoneSuccess,
      (_state, { timezonesList }) => { return { ..._state, timezonesList } }),
);